module.exports = __webpack_public_path__ + "static/img/图层 566 拷贝.32e9ae1a.png";